import { render, staticRenderFns } from "./dialogprodVega.vue?vue&type=template&id=2e212fce&scoped=true"
import script from "./dialogprodVega.vue?vue&type=script&lang=js"
export * from "./dialogprodVega.vue?vue&type=script&lang=js"
import style0 from "./dialogprodVega.vue?vue&type=style&index=0&id=2e212fce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e212fce",
  null
  
)

export default component.exports